export default __webpack_public_path__ + "static/media/Blue-Android-7.eb8f08f9.png";